import { render, staticRenderFns } from "./ReservationWaitingPage.vue?vue&type=template&id=7167d8d0"
import script from "./ReservationWaitingPage.vue?vue&type=script&lang=js"
export * from "./ReservationWaitingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports